export enum LoadingStatus {
    NOT_LOADED = 'not loaded',
    LOADING = 'loading',
    LOADED = 'loaded',
    ERROR = 'error'
}